import { Transaction } from "./Transaction";
import { GICTransaction } from "./GICTransaction";
import { CashTransaction } from "./CashTrasanction";
import { BondTransaction } from "./BondTransaction";
import { Price } from "./Price";
import Holding from "./Holding";
import { ITransRow } from "../shared/ITransaction";

export default function createTrans(ticker:string, holding:Holding, json:ITransRow):Transaction{
    if (Price.isGIC(ticker) || Price.isSave(ticker)) return new GICTransaction(holding, json)
    else if (Price.isBond(ticker)) return new BondTransaction(holding, json)
    else if (Price.isCash(ticker)) return new CashTransaction(holding, json)
    else return new Transaction(holding,json)
}